// extracted by mini-css-extract-plugin
export default {"market":"styles_market__4+ovr","body":"styles_body__OA4tr","cups":"styles_cups__gNG+N","lines":"styles_lines__6pg+s","data":"styles_data__hYN1M","bets":"styles_bets__U6TFY"};